module.exports = __webpack_public_path__ + "static/media/mmg_6.5'_screenshot_4.ad516a8b.png";